import React, { ReactNode } from "react";
import { Figure } from "../figure/figure";
interface Props {
    children: ReactNode,
    tpl?: 'default' | 'new',
    share?: string
}
const Heading = ({ children, tpl = 'default', share = '' }: Props) => {
    const handleShare = async () => {
        const url = 'https://t.me/Svoi_msk_bot?startapp=' + share;
        const title = "Поделиться";

        if (navigator.share) {
            await navigator.share({ title, url });
            return;
        }

        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(url);
        }
        else {

        }
    };

    if (tpl === 'new')
        return (
            <div className="mb-3 pt-3 border-b sticky bg-white z-10 top-0 pb-1.5 flex items-center justify-between">
                <div className="flex-grow heading-title-new">{children}</div>
                {share && (
                    <button onClick={handleShare} className="my-text-primary">
                        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.7501 8.21667L14.1946 0.75V5.01667C5.63901 6.08333 1.97234 11.4167 0.750122 16.75C3.80568 13.0167 8.08345 11.31 14.1946 11.31V15.6833L22.7501 8.21667Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                        </svg>
                    </button>
                )}
            </div>
        );
    else
        return (
            <div className="flex items-center flex-col gap-2 mb-8">
                <div className="heading-title">{children}</div>
                <Figure />
            </div>
        );
}

export default Heading;
